<template>
  <div :class="{ invalid: errorText }">
    <label
      v-if="label"
      :class="[
        'block mb-2 text-sm font-medium',
        {
          'text-gray-900 dark:text-white': !errorText,
          'text-red-700 dark:text-red-500': errorText
        }
      ] ">
      {{ label }}
    </label>
    <input
      id="twilio-phone-input"
      type="text"
      :class="{
        'iti__tel-input': !errorText,
        'iti__tel-input invalid': errorText
      }"
      @change="onChange"
      @countrychange="onChange">
    <p v-if="errorText" class="mt-2 text-sm text-red-600 dark:text-red-500">
      {{ errorText }}
    </p>
    <p v-else-if="helper" class="mt-2 text-sm text-gray-500 dark:text-gray-400">
      {{ helper }}
    </p>
    <input type="hidden" v-bind="useAttrs()" :value="iti?.getNumber() ? iti.getNumber() : modelValue">
  </div>
</template>

<script setup>
import { ref, onMounted, useAttrs } from 'vue'
import intlTelInput from 'intl-tel-input'

const emits = defineEmits(['update:modelValue', 'updateErrors'])
const props = defineProps({
  modelValue: { type: String, default: '' },
  label: { type: String, default: '' },
  helper: { type: String, default: '' },
  errorText: { type: String, default: '' }
})

const iti = ref(null)

onMounted(() => {
  const input = document.getElementById('twilio-phone-input')
  intlTelInput(input, {
    utilsScript: 'https://cdn.jsdelivr.net/npm/intl-tel-input@24.1.1/build/js/utils.js',
    autoPlaceholder: 'aggressive',
    initialCountry: 'us',
    onlyCountries: [],
    separateDialCode: true
  })

  iti.value = intlTelInput.getInstance(input)
  iti.value.setNumber(props.modelValue)
})

const setErrorObj = (errTxt) => ({
  details: {
    ringThroughNumber: [errTxt]
  }
})

const onChange = () => {
  if (iti.value.isValidNumber() === null) return

  switch (iti.value.getValidationError()) {
    case 0: break
    case 2:
      emits('updateErrors', setErrorObj('Number is too short.'))
      break
    case 3:
      emits('updateErrors', setErrorObj('Number is too long.'))
      break
    default:
      emits('updateErrors', setErrorObj('Invalid number.'))
  }

  emits('update:modelValue', iti.value.getNumber())
}
</script>
